import { Highcharts_lang_se } from "./lang/se";

// Global Highcharts configuration.
const config = {
  credits: false,
  time: {
    useUTC: false,
  },
  lang: Highcharts_lang_se,
};

export default config;
